<template>
  <div>
    <v-tabs>
      <v-tabs-slider></v-tabs-slider>

      <v-tab>Broadcast List</v-tab>
      <v-tab>Message Templates</v-tab>

      <v-tab-item>
        <v-card>
          <v-data-table
            :headers="blHeaders"
            :items="broadcastLists"
            :loading="loading"
            :server-items-length="totalBroadcastLists"
            :options.sync="blOptions"
          >
            <template v-slot:item.dated="{ item }">
              {{ $date.utcToLocal(item.dated) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn text @click="assignItem(item)" class="mr-1">
                <v-icon small>assignment</v-icon> Assign
              </v-btn>
              <v-btn text @click="editItem(item)" class="mr-1">
                <v-icon small>edit</v-icon> Edit
              </v-btn>
              <v-btn text @click="viewItem(item)" class="mr-1">
                <v-icon small>remove_red_eye</v-icon> View
              </v-btn>
              <v-btn text @click="deleteBroadcastList(item)" color="red">
                <v-icon small>delete</v-icon> Delete
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-data-table
            :headers="mtHeaders"
            :items="messageTemplates"
            :loading="loading"
            :server-items-length="totalTemplates"
            :options.sync="mtOptions"
          >
            <template v-slot:item.dated="{ item }">
              {{ $date.utcToLocal(item.dated) }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn text @click="viewItem(item)" class="mr-1">
                <v-icon small>remove_red_eye</v-icon> View
              </v-btn>
              <v-btn
                text
                @click="assignItem(item)"
                class="mr-1"
                v-if="item.installed === 0"
              >
                <v-icon small>assignment</v-icon> Assign
              </v-btn>
              <v-btn
                text
                @click="assignItem(item)"
                class="mr-1"
                v-if="item.installed === 1"
              >
                <v-icon small>assignment</v-icon> Re-Assign
              </v-btn>
              <v-btn
                text
                @click="deleteMessageTemplate(item)"
                color="red"
                v-if="item.installed === 0"
              >
                <v-icon small>delete</v-icon> Delete
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { broadcastLists as api } from "@/api";
export default {
  name: "BroadcastLists",
  data: () => ({
    loading: false,
    blOptions: {},
    mtOptions: {},
    blHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Name", value: "name" },
      { text: "Actions", value: "action", sortable: false },
    ],
    mtHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Message", value: "message" },
      { text: "Actions", value: "action", sortable: false },
    ],
    messageTemplates: [],
    totalTemplates: 0,
    broadcastLists: [],
    totalBroadcastLists: 0,
    search: "",
  }),
  filters: {
    number: function (value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },
  },
  watch: {
    blOptions: {
      handler() {
        this.getBroadcastLists();
      },
      deep: true,
    },
    mtOptions: {
      handler() {
        this.getMessageTemplates();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getBroadcastLists();
      this.getMessageTemplates();
    },

    async getBroadcastLists() {
      const { page = 1, itemsPerPage = 10 } = this.blOptions;
      this.loading = true;
      const response = await api.getBroadcastLists(itemsPerPage, page);
      this.totalBroadcastLists = response.data.count;
      this.broadcastLists = response.data.data;
      this.loading = false;
    },
    async deleteBroadcastList(item) {
      const confirm = await this.$alert.confirm(
        `Delete Broadcast List #${item.id} ?`
      );
      if (confirm && confirm.value === true) {
        try {
          await api.removeBroadcastList([item.id]);
          this.$toast.success("Deleted Successfully");
          this.getBroadcastLists();
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
    },
    async getMessageTemplates() {
      const { page = 1, itemsPerPage = 10 } = this.mtOptions;
      this.loading = true;
      const response = await api.getMessageTemplates(
        this.search,
        itemsPerPage,
        page
      );
      this.totalTemplates = response.data.count;
      this.messageTemplates = response.data.data;
      this.loading = false;
    },
    async deleteMessageTemplate(item) {
      const confirm = await this.$alert.confirm(
        `Delete Message Template #${item.id} ?`
      );
      if (confirm && confirm.value === true) {
        try {
          await api.removeMessageTemplate([item.id]);
          this.$toast.success("Deleted Successfully");
          this.getMessageTemplates();
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
    },

    editBroardCastList(item) {
      this.$router.push(`batteries/${item.id}`);
    },
    editMessageTemplate(item) {
      this.$router.push(`batteries/${item.id}`);
    },
    sendMessage(broadcastId, templateId) {
      console.log("broadcastId", broadcastId);
      console.log("templateId", templateId);
    },
  },
  mounted() {
    // this.initialize();
  },
};
</script>